import { array, number, object, parse } from 'valibot'
import { bookAndArticleSchema } from '~/utils/solr/literature'

const bookEditionsResponse = object({
  editions: array(bookAndArticleSchema),
  total: number(),
})

export function useFetchBookEditions(bookId: MaybeRef<string | null | undefined>) {
  return useQuery({
    enabled: computed(() => !!toValue(bookId)),
    queryKey: ['book-editions', bookId],
    queryFn: async ({ signal, queryKey }) => await $fetch<unknown>(`/api/solr/literature/editions/${queryKey[1]}`, { signal }),
    select: (res) => {
      return parse(bookEditionsResponse, res)
    },
  })
}
